import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '20px',
    animation: '$fadeIn 0.3s ease-out',
  },
  overlayClosing: {
    animation: '$fadeOut 0.3s ease-in forwards',
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    width: '520px',
    maxWidth: '90vw',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.2)',
    overflow: 'hidden',
    animation: '$slideUp 0.3s ease-out',
  },
  modalClosing: {
    animation: '$slideDown 0.3s ease-in forwards',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '1.5rem 1.5rem 1rem',
    borderBottom: '1px solid #e5e7eb',
  },
  title: {
    fontWeight: 700,
    fontSize: '1.125rem',
    color: '#1a1a1a',
    marginBottom: '0.25rem',
  },
  subtitle: {
    fontSize: '0.8125rem',
    color: '#6b7280',
  },
  body: {
    padding: '1.5rem',
    flex: 1,
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '0.75rem',
    padding: '1rem 1.5rem',
    borderTop: '1px solid #e5e7eb',
    backgroundColor: '#f9fafb',
  },
  validationError: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginTop: '0.75rem',
    padding: '0.625rem 0.875rem',
    backgroundColor: '#fef2f2',
    borderRadius: '8px',
    border: '1px solid #fecaca',
  },
  validationErrorText: {
    fontSize: '0.8125rem',
    color: '#991b1b',
    fontWeight: 500,
  },
  '@keyframes slideUp': {
    from: { opacity: 0, transform: 'translateY(30px) scale(0.97)' },
    to: { opacity: 1, transform: 'translateY(0) scale(1)' },
  },
  '@keyframes slideDown': {
    from: { opacity: 1, transform: 'translateY(0) scale(1)' },
    to: { opacity: 0, transform: 'translateY(30px) scale(0.97)' },
  },
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  '@keyframes fadeOut': {
    from: { opacity: 1 },
    to: { opacity: 0 },
  },
});

export default useStyles;
